import React, {Fragment, useState, useEffect} from "react";
import {Dropdown} from "react-bootstrap";
import userImage from "../../../../assets/img/demo/user-jack-scot.png";
import { NavLink } from "react-router-dom";
import { ThemeSwitch } from "../../ThemeProvider";

const HeaderRightSide = props => {

    return (
        <Fragment>
            <div className="menu-right">
                <ThemeSwitch onThemeChange={props.onThemeChange} />
                <div className="divider"></div>
                <div className="user-menu">
                    <Dropdown alignRight>
                        <Dropdown.Toggle variant="default" id="dropdown-basic">
                            <span className="username">Jack Scot</span>
                            <img src={userImage} alt="Jack Scot"/>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item as={NavLink} to="/profile-settings">Profile Settings</Dropdown.Item>
                            <Dropdown.Item href="#/action-2">Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </Fragment>
    );
};

export default HeaderRightSide;